module.exports = __webpack_public_path__ + "02_mustache_brown.721d7263.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/02_mustache_brown.png
// module id = dbql
// module chunks = 0